import React from 'react';
import PropTypes from 'prop-types';
import TemplateList from '../../components/templateList';

export default function OrgaTemplateList({ organization }) {
    return <TemplateList organization={organization} />;
}

OrgaTemplateList.propTypes = {
    organization: PropTypes.object.isRequired
};
